import { BuchungsheldLitElement } from '@adornis/buchungsheld-components/BuchungsheldLitElement.js';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';

/**
 * @element bh-page-not-found
 */
@customElement('bh-page-not-found')
export class BhPageNotFound extends BuchungsheldLitElement {
  override styles() {
    return [...super.styles(), { ':host': { display: 'flex', justifyContent: 'center', alignItems: 'center' } }];
  }

  override render() {
    return html`
      <x-empty-placeholder
        no-wrapper
        .text=${this._translation.translate('PAGE_NOT_FOUND')}
        back-text="Zurück"
        .img=${'close'}
      ></x-empty-placeholder>
    `;
  }
}
